import React from 'react';
import { Box, Button, IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import TuneIcon from '@mui/icons-material/Tune';

interface TabletTopBarControlsProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  onOpenCategoryDrawer: () => void;
  onOpenFilters: () => void;
  multiSelectEnabled: boolean;
  selectedAssetCount: number;
  onToggleMultiSelect: () => void;
}

export default function TabletTopBarControls({
  searchTerm,
  onSearchTermChange,
  onOpenCategoryDrawer,
  onOpenFilters,
  multiSelectEnabled,
  selectedAssetCount,
  onToggleMultiSelect,
}: TabletTopBarControlsProps) {
  const selectionLabel = multiSelectEnabled
    ? selectedAssetCount > 0
      ? `Avsluta (${selectedAssetCount})`
      : 'Avsluta'
    : 'Markera';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flex: 1,
        minWidth: 0,
        maxWidth: 560,
      }}
    >
      <Tooltip title="Meny">
        <IconButton color="inherit" onClick={onOpenCategoryDrawer} aria-label="Öppna meny">
          <MenuIcon />
        </IconButton>
      </Tooltip>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextField
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          placeholder="Sök…"
          size="small"
          fullWidth
          variant="outlined"
          sx={{
            bgcolor: 'white',
            borderRadius: 1,
            '& .MuiOutlinedInput-root': {
              height: 40,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: searchTerm ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  aria-label="Rensa sök"
                  onClick={() => onSearchTermChange('')}
                  edge="end"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : undefined,
          }}
        />
      </Box>

      <Tooltip title="Filter">
        <IconButton color="inherit" onClick={onOpenFilters} aria-label="Öppna filter">
          <TuneIcon />
        </IconButton>
      </Tooltip>

      <Button
        variant={multiSelectEnabled ? 'contained' : 'outlined'}
        color="inherit"
        onClick={onToggleMultiSelect}
        aria-pressed={multiSelectEnabled}
        sx={{
          height: 40,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          borderColor: 'rgba(255,255,255,0.7)',
          bgcolor: multiSelectEnabled ? 'rgba(255,255,255,0.92)' : 'transparent',
          color: multiSelectEnabled ? '#072f53' : 'inherit',
          '&:hover': {
            bgcolor: multiSelectEnabled ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.12)',
            borderColor: 'rgba(255,255,255,0.9)',
          },
        }}
      >
        {selectionLabel}
      </Button>
    </Box>
  );
}
